export const ICON_VISA = "visa";
export const ICON_STAR = "star";

export const ICONS = {
  [ICON_VISA]: ICON_VISA,
  [ICON_STAR]: ICON_STAR,
};

export const SUCCES_ICON_TYPE = "success";
export const WARNING_ICON_TYPE = "warning";
export const DANGER_ICON_TYPE = "danger";
